import React from "react";
import { siteConfig } from "../../config/siteConfig";
import Icon from "../ui/Icon";
import SealChip from "../ui/SealChip";

// Banda de confianza con HECHOS reales (no testimonios). Se oculta sola si la
// niche no define siteConfig.trustStrip.
//
// Premium (DESIGN-SPEC §4 TrustBar) : filet hairline avec dividers verticaux
// slate ; chaque emoji remplacé par un <Icon> 1.5px dans une chip teal ; un
// <SealChip> « oficial » scelle la bande quand le label existe en config.
const TrustBar = () => {
  const items = siteConfig.trustStrip;
  if (!items || items.length === 0) return null;

  // Label « oficial » du sceau récurrent — toujours issu de la config (fallback sûr).
  const sealLabel = siteConfig.sealLabels?.official || "";

  return (
    <section
      className="bg-white border-y border-slate-200/70"
      aria-label="Takuut ja luotettavuus"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 sm:divide-x sm:divide-slate-200/70">
          {items.map((it, i) => (
            <div
              key={i}
              className="inline-flex items-center gap-2.5 text-sm font-semibold text-slate-600 sm:px-6 sm:first:pl-0 sm:last:pr-0"
            >
              {/* Chip teal · icône line 1.5px (currentColor hérité, recolor-safe) */}
              <span
                className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-teal-50 text-teal-700 ring-1 ring-inset ring-teal-100"
                aria-hidden="true"
              >
                {it.iconKey ? (
                  <Icon name={it.iconKey} className="w-4 h-4" />
                ) : it.icon ? (
                  <span className="text-base leading-none">{it.icon}</span>
                ) : null}
              </span>
              <span>{it.label}</span>
            </div>
          ))}

          {/* Sceau « oficial » qui scelle la bande (si le label existe en config). */}
          {sealLabel ? (
            <div className="inline-flex items-center sm:px-6 sm:last:pr-0">
              <SealChip label={sealLabel} icon="seal" tone="teal" />
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
